import React, { createContext, useContext, useState } from "react"

export type SystemModeType = "KITCHEN" | "STAFF"

interface SystemModeContextData {
  systemMode: SystemModeType
  setSystemMode: (mode: SystemModeType) => void
}

const SystemModeContext = createContext<SystemModeContextData | null>(null)

export const SystemModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [systemMode, setSystemMode] = useState<SystemModeType>("STAFF")

  return <SystemModeContext.Provider value={{ systemMode, setSystemMode }}>{children}</SystemModeContext.Provider>
}

export const useSystemMode = () => {
  const context = useContext(SystemModeContext)

  if (!context) {
    throw new Error("useSystemMode must be used inside SystemModeProvider")
  }

  return context
}
